import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Filter3Icon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_3"}/>
}
